/* eslint-disable */
import cookies from 'vue-cookies'
import util from './util'

import {
  getMessaging,
  deleteToken
} from "firebase/messaging"

function identify(routes) {
  if (!cookies.get('identifier') && util.validate(routes.filter(path => {
      return window.location.pathname.toLowerCase().includes(path)
    })))
    logout(routes)
}

function logout(routes = []) {
  if (window.location.pathname !== '/Authentication') {
    localStorage.removeItem('modules')
    localStorage.removeItem('utm_source')
    localStorage.removeItem('utm_medium')
    localStorage.removeItem('utm_campaign')
  }

  ['identifier', 'uid', 'gid', 'rid', 'grade', 'username', 'mobile', 'display_name', 'referral_code', 'balance', 'inprocess', 'fcm']
  .forEach((cookie) => cookies.remove(cookie))

  const messaging = getMessaging()
  deleteToken(messaging).then(() => {}).catch((err) => {})

  if (util.validate(routes.filter(path => {
      return window.location.pathname.toLowerCase().includes(path)
    })))
    window.location.href = '/Authentication'
}

export default {
  identify,
  logout
}
